import * as React from "react";
const IconLc = (props) => (
  <svg className={"fill-current"}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 513 342"
    width={props.size || "48"}
    height={props.size || "48"}
    {...props}
  >
    <path  d="M0 0h513v342H0z" />
    <path  d="M148.5 298.1h216l-108-254.2z" />
    <path  d="m186 272.7 70.5-160.3L327 272.7z" />
    <path  d="M148.5 298.1h216l-108-101.7z" />
  </svg>
);
export default IconLc;
